<script setup lang="ts">
const emit = defineEmits(["close"]);
const { createAuthAttemptAndRedirect } = useAuthController();
const route = useRoute();
const router = useRouter();
const localePath = useLocalePath();
const redirect = ref("");
const methodChoice = ref<"email" | "apple" | "facebook" | "google" | null>(
  null
);

onMounted(() => {
  if (route.query.redirect) {
    redirect.value = route.query.redirect as string;
    const decodedRedirect = decodeURIComponent(redirect.value);
    if (decodedRedirect.includes("forceLogin")) {
      const forceLoginValue = decodedRedirect.match(/forceLogin=([^&]*)/)?.[1];
      if (
        forceLoginValue === "email" ||
        forceLoginValue === "apple" ||
        forceLoginValue === "facebook" ||
        forceLoginValue === "google"
      ) {
        methodChoice.value = forceLoginValue;
      }
      openOAuth("signup");
    }
  } else if (route.query.forceLogin !== undefined) {
    openOAuth("signup");
  }
});

const openOAuth = (type: string) => {
  createAuthAttemptAndRedirect(
    type,
    getCurrentFullPath(redirect.value),
    false,
    methodChoice.value
  );
  emit("close");
};

const handleClose = () => {
  const currentMerchant = useAppStateStore().currentMerchant;
  currentMerchant
    ? router.push(localePath(`/store/${currentMerchant}`))
    : router.push("/");
  emit("close");
};
</script>
<template>
  <BaseLayoutModal width="medium" @close="handleClose" @mouse-up="handleClose">
    <template #header>
      <p class="">{{ $t("main.modalBuyLogin.signIn") }}</p>
    </template>
    <template #content>
      <p class="text-neutral-300 font-light">
        {{ $t("main.modalBuyLogin.transactionInstruction").split(".")[1] }}
      </p>
      <div class="mt-5 mb-2 sm:mt-6 flex">
        <div class="flex flex-col gap-4">
          <div class="flex items-center gap-4">
            <BaseButtonSubmit
              class="w-44"
              data-test="button-login"
              @click="openOAuth('signup')">
              <template #text>
                <span class="text-lg">{{
                  $t("main.modalBuyLogin.signIn")
                }}</span>
              </template>
            </BaseButtonSubmit>
            <BaseButtonCancel
              data-test="button-login-cancel"
              @click="handleClose">
              <template #text>
                <span class="text-lg">{{
                  $t("main.modalBuyLogin.cancel")
                }}</span>
              </template>
            </BaseButtonCancel>
          </div>
        </div>
      </div>
    </template>
  </BaseLayoutModal>
</template>
